import { render, staticRenderFns } from "./kfw.vue?vue&type=template&id=720c8f74&scoped=true&"
var script = {}
import style0 from "./kfw.vue?vue&type=style&index=0&id=720c8f74&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "720c8f74",
  null
  
)

export default component.exports